// extracted by mini-css-extract-plugin
module.exports = {"label":"formSelect_label__2n3tK","select":"formSelect_select__3Kz_s"};